import { Region, RelocationStatus } from "@/gql/graphql";

export type RelocationTableState = {
  statuses: RelocationStatus[];
  supplierId: string | null;
  regions: Region[];
  departureCityIds: string[];
  deliveryCityIds: string[];
  page: number;
  search: string;
};

export const defaultRelocationTableState: RelocationTableState = {
  statuses: [],
  supplierId: null,
  regions: [],
  departureCityIds: [],
  deliveryCityIds: [],
  page: 1,
  search: "",
};
